"use client";

import { useFormikContext } from "formik";

import Input from "@client/components/formik/input";

export default function FormikPhoneNumber({
  id = "phone-number",
  name = "phoneNumber",
}: {
  id: string;
  name: string;
}) {
  const { setFieldValue } = useFormikContext<any>();

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value.replaceAll(/[^0-9]/g, "").slice(0, 10);

    if (value.length === 10) {
      value = value.replace(/(\d{3})(\d{3})(\d+)/, "$1-$2-$3");
    } else if (value.length > 6) {
      value = value.replace(/(\d{3})(\d{3})(\d+)/, "$1-$2-$3");
    } else if (value.length > 3) {
      value = value.replace(/(\d{3})(\d{0,3})/, "$1-$2");
    }

    setFieldValue(name, value);
  };

  return (
    <Input
      id={id}
      type="tel"
      name={name}
      inputMode="numeric"
      placeholder="xxx-xxx-xxxx"
      onChange={handleOnChange}
    />
  );
}
